var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistPaymentExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#2614a0",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-100.691c-15.962 0-29.033 13.072-29.033 29.066v236.812c0 15.994 13.071 29.066 29.033 29.066h16.281m333.563 0h16.252c15.991 0 29.062-13.072 29.062-29.066V29.066C294.467 13.072 281.396 0 265.405 0H35.308",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(142.724 7.5)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-168.3 108.659",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(437.191 36.566)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 165.553 106.288",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(13 36.566)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v213.5c0 7.37 6.05 13.42 13.42 13.42h306.73c7.37 0 13.42-6.05 13.42-13.42v-3.8",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(58.31 231.01)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v103.29",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(391.88 235.4)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 49.883-36.558 115.67-84.827 33.371-24.468c12.087-8.85 8.27-8.85 20.387 0l36.581 26.839 112.43 82.456 55.869 40.954",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(13 264.24)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 110.841 123.438c7.837 8.735 22.18 8.763 31.867.087l7.75-6.97 7.75-6.97c9.688-8.677 11.191-22.936 3.325-31.698L-1.648-103.858l-75.012-37.165c-3.181-1.273-5.524.838-4.598 4.136l28.889 78.551 29.38 32.74",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(332.423 374.49)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-50.721 45.522",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(330.774 270.63)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 50.692-45.552",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(421.662 473.864)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-27.646 24.844",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(293.269 252.034)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h126.427",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(124.072 351.092)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h49.709",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(124.072 399.853)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h97.77",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(124.072 302.33)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h132.153",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(124.072 253.567)",
    fill: "none",
    stroke: "#2614a0",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistPaymentExtension);
export default __webpack_public_path__ + "static/media/assist-payment-extension.e5d9c9899bfcfbfa334c9b01694269eb.svg";
export { ForwardRef as ReactComponent };